import { PaginatorDesignTokens } from '@primeuix/themes/types/paginator';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/paginator/index.ts
const pg = componentCommon.paginator;
const pgDeep = tDeep(pg);

export const PaginatorTelekomDT: PaginatorDesignTokens = {
  root: {
    padding: `${pgDeep.padding.y} ${pgDeep.padding.x}`,
    gap: t(pg.gap),
    borderRadius: t(pg.border.radius),
    background: t(pg.background),
    color: t(pg.color),
  },
  navButton: {
    background: t(pg.nav.button.background),
    hoverBackground: t(pg.nav.button.hover.background),
    selectedBackground: t(pg.nav.button.selected.background),
    color: t(pg.nav.button.color),
    hoverColor: t(pg.nav.button.hover.color),
    selectedColor: t(pg.nav.button.selected.color),
    width: t(pg.nav.button.width),
    height: t(pg.nav.button.height),
    borderRadius: t(pg.nav.button.border.radius),
    focusRing: {
      width: t(pg.nav.button.focus.ring.width),
      color: t(pg.nav.button.focus.ring.color),
      offset: t(pg.nav.button.focus.ring.offset),
    },
  },
  currentPageReport: {
    color: t(pg.current.page.report.color),
  },
  jumpToPageInput: {
    maxWidth: t(pg.jump.to.page.input.max.width),
  },
};
